const HOVER_OPACITY = 0.08;
const ACTIVE_OPACITY = 0.16;

export { HOVER_OPACITY, ACTIVE_OPACITY };
